import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParamsGeneric } from '../../../../../core/models/RouteParams';
import ProjectContractorItemsImportForm from './ProjectContractorItemsImportForm';

interface OwnProps {
    projectId: number;
    projectContractorId: number;
    onClose: () => void;
    onSuccess: () => void;
    isEditMode: boolean;
}

export type Props = OwnProps & RouteComponentProps<RouteParamsGeneric>;

export default withRouter(ProjectContractorItemsImportForm);
